import globalIP from '@/GlobelIP';
import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Message, SelectPicker, Stack, Table, Toggle, useToaster } from 'rsuite';
const { Column, HeaderCell, Cell } = Table;

const PReg = () => {
  const ip = globalIP;
  const [tableHeight, setTableHeight] = useState(20); // Default height
  useEffect(() => {
    const calculateHeight = () => {
      const headerHeight = 250; // Adjust based on your header/footer size
      const footerHeight = 5; // Adjust based on your footer size
      const availableHeight = window.innerHeight - headerHeight - footerHeight;
      setTableHeight(availableHeight);
    };
    calculateHeight();
    window.addEventListener('resize', calculateHeight); // Recalculate on window resize
    return () => window.removeEventListener('resize', calculateHeight);
  }, []);
  const handleSelectChange = async (selectedOption) => {
    setAliasShort(selectedOption); // Update the selected value in the state

    try {
      const response = await fetch(
        `${globalIP}/api/company-details/${companyid}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: { AliasShort: selectedOption }, // Save the selected option
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      // console.log("Update successful");
    } catch (error) {
      console.error("Error updating AliasShort:", error);
      // Handle error if needed
    }
  };
  const [label, setLabel] = useState({
    Category: '',
    ProductType: '',
    AliasCode: '',
    ProductName: '',
    Description: '',
    Sizeunit: '',
    length: '',
    width: '',
    height: '',
    cbm: '',
    finish: '',
    color: '',
    HSN: '',
    NetWgt: '',
    GrossWgt: '',
    MOQ: '',
    Currency: '',
    CurRate: '',
    SalePrice: '',
    SalePriceINR: '',
    ProductDesigner: '',
    MadeBy: '',
    ProductRemark: '',
    searchKeyword: '',
    BuyerName: '',
    BuyerSku: '',
    BuyerRemark: '',
    MaterialName: '',
    Shape: '',
    Collection: '',
    Season: '',
    P_Technique: '',
    SizeRange: ''
  });
  const [isEditing, setIsEditing] = useState(false);
  const [labelId, setLabelID] = useState(null);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const requiredFeilds = ['Category', 'AliasCode', 'ProductName'];
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      const extractedData = json.data[0].attributes;
      setLabel(extractedData);
      setLabelID(json.data[0]?.id);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  const handleEditClick = () => {
    setIsEditing(prevState => !prevState);
  };
  const excludedFields = ['createdAt', 'updatedAt', 'publishedAt'];
  const attributes = Object.entries(label)
    .filter(([key]) => !excludedFields.includes(key))
    .map(([key, value]) => ({
      attribute: key,
      value: value
    }));
  const handleInputChange = (fieldName, value) => {
    setLabel(prevState => ({
      ...prevState,
      [fieldName]: value
    }));
  };
  const toaster = useToaster();
  const handleSave = async () => {
    try {
      // Trim and check if any field is empty
      const trimmedLabel = Object.fromEntries(
        Object.entries(label).map(([key, value]) => [key, value.trim()])
      );
      const isEmpty = Object.values(trimmedLabel).some(value => value === '');
      if (isEmpty) {
        toaster.push(
          <Message showIcon type="error">
            Please fill all fields.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit the function early if any field is empty
      }
      // Check for duplicate values in a case-insensitive manner
      const lowercaseValues = Object.values(trimmedLabel).map(value => value.toLowerCase());
      const valueOccurrences = lowercaseValues.reduce((acc, value) => {
        acc[value] = (acc[value] || 0) + 1;
        return acc;
      }, {});
      // console.log('valueOccurrences', valueOccurrences);
      const hasDuplicates = Object.values(valueOccurrences).some(count => count > 1);
      if (hasDuplicates) {
        toaster.push(
          <Message showIcon type="error">
            Duplicate values detected! Please ensure all fields are unique.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Exit the function if duplicates are found
      }
      // Perform the save operation if validation passes
      const response = await fetch(`${globalIP}/api/product-labels/${labelId}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: trimmedLabel })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchDatalabel();
        toaster.push(
          <Message showIcon type="success">
            Saved Changes.
          </Message>,
          { placement: 'topEnd' }
        );
        setIsEditing(false); // Exit editing mode after saving
      }
    } catch (error) {
      console.error('Error updating label:', error);
    }
  };
  const [status, setStatus] = useState(false);
  const [companyid, setCompanyid] = useState(0);

  const [fileInfo1, setFileInfo1] = useState({
    PPT_coverpage: null,
    PPT_footerpage: null,
    PDF_coverpageH: null,
    PDF_footerpageH: null,
    PDF_coverpageV: null,
    PDF_footerpageV: null,
    excel_banner: null
  });
  const [aliasShort, setAliasShort] = useState(null);
  useEffect(() => {
    fetchDatacompany();
  }, []);
  const fetchDatacompany = async () => {
    try {
      const response = await fetch(`${ip}/api/company-details?populate=*`);
      const json = await response.json();
      const extractedData = json.data[0].attributes.FreeSize;
      const extractedid = json.data[0].id;
      setAliasShort(json.data[0].attributes.AliasShort);
      setFileInfo1(prev => ({
        ...prev,
        PPT_coverpage: `${ip}${json.data[0]?.attributes?.PPT_coverpage?.data?.attributes?.url ?? ''
          }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PPT_footerpage: `${ip}${json.data[0]?.attributes?.PPT_footerpage?.data?.attributes?.url ?? ''
          }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_coverpageH: `${ip}${json.data[0]?.attributes?.PDF_coverpageH?.data?.attributes?.url ?? ''
          }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_footerpageH: `${ip}${json.data[0]?.attributes?.PDF_footerpageH?.data?.attributes?.url ?? ''
          }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_coverpageV: `${ip}${json.data[0]?.attributes?.PDF_coverpageV?.data?.attributes?.url ?? ''
          }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        PDF_footerpageV: `${ip}${json.data[0]?.attributes?.PDF_footerpageV?.data?.attributes?.url ?? ''
          }`
      }));
      setFileInfo1(prev => ({
        ...prev,
        excel_banner: `${ip}${json.data[0]?.attributes?.excel_banner?.data?.attributes?.url ?? ''}`
      }));
      setCompanyid(extractedid);
      setStatus(extractedData);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };

  return (
    <>
      <Table
        height={tableHeight}
        data={attributes}
        style={{ marginTop: '10px' }}
        bordered
        cellBordered
      >
        <Column width={80} align="left" resizable>
          <HeaderCell>
            <b>Visibility</b>
          </HeaderCell>
          <Cell style={{
            alignItems: "center",
            display: "flex"
          }}>
            {(rowData) => (

              <Checkbox disabled={requiredFeilds.includes(rowData.attribute)} />
            )}

          </Cell>
        </Column>
        <Column width={200} align="left" resizable>
          <HeaderCell>
            <b>Attributes</b>
          </HeaderCell>
          <Cell dataKey="attribute" />
        </Column>
        <Column width={300} align="left" resizable>
          <HeaderCell>
            <b>Your Caption</b>
          </HeaderCell>
          <Cell>
            {rowData =>
              isEditing ? (
                <input
                  className="rs-input"
                  value={rowData.value}
                  onChange={e => handleInputChange(rowData.attribute, e.target.value)}
                  style={{ width: '100%', padding: '4px' }}
                />
              ) : (
                <span>{rowData.value}</span>
              )
            }
          </Cell>
        </Column>
        <Column width={400} align="center" resizable>
          <HeaderCell>
            <b>Settings</b>
          </HeaderCell>
          <Cell>
            {rowData =>
              rowData.attribute === 'AliasCode' ? (

                <SelectPicker
                  data={[
                    { label: 'Manual', value: 'Manual' },
                    { label: 'Cate.Shortname + Auto', value: 'Cate.Shortname + Auto' },
                    { label: 'Cate.Shortname + Manual', value: 'Cate.Shortname + Manual' },
                  ]}
                  value={aliasShort}
                  onChange={async (value) => {
                    await handleSelectChange(value);
                  }}
                  placeholder="Select Mode"
                  style={{ width: 200, marginTop: '-8px' }}
                />

              ) : (
                <span>-</span> // Placeholder for other rows
              )
            }
          </Cell>
        </Column>
      </Table>
      <Stack justifyContent="space-between" style={{ marginTop: '10px' }}>
        <Button appearance="subtle" active onClick={handleEditClick}>
          {isEditing ? 'Close' : 'Edit'}
        </Button>
        <Stack className="setting-mstr-panel">
          {isEditing && (
            <Button
              appearance="primary"
              color="cyan"
              onClick={handleSave}
              className="mstr-btn-setting1"
            >
              Save
            </Button>
          )}
        </Stack>
      </Stack>
    </>
  );
};

export default PReg;
